import React, { useState } from 'react';

import GradeModal from '../GradeModal';
import Grade from '../../../components/Grade';
import { useSuspensionStatus } from '../../../../utils/effects/useSuspensionStatus';

const GradeSystem = ({ grade, list, loading, handleDownloadGrade, companyId, userType }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const isSuspended = useSuspensionStatus();

  return (
    <>
      <Grade grade={grade} handleClick={() => setModalOpen(true)} disabled={isSuspended} />
      <GradeModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        list={list}
        loading={loading}
        handleDownloadGrade={handleDownloadGrade}
        companyId={companyId}
        userType={userType}
      />
    </>
  );
};

export default GradeSystem;
